module.exports = __webpack_public_path__ + "img/z-2.440a26e3.png";